var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-title',[_vm._v(" Créer tâche récurrente ")]),_c('card',[_c('create-or-update-recurring-task-form',{attrs:{"mode":"create"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }